import React from 'react';

const StatDisplay = ({ title, value, change, period, color }) => {
  // Format the change value to show + for positive numbers
  const formattedChange = change
    ? `${change > 0 ? '+' : ''}${change}%`
    : null;

  return (
    <div className="flex flex-col">
        <div className={'flex items-center'}>
            {color && (
                <div style={{background: color}} className={'h-3 w-3'}></div>
            )}
            <span className="text-sm font-medium mb-0.5 card-label ml-2">{title}</span>

        </div>
        <div className="flex items-baseline gap-2">
            <span className="text-lg card-value">{value}</span>
        {formattedChange && (
          <span className={`text-sm font-medium ${change >= 0 ? 'text-green-500' : 'text-red-500'}`}>
            {formattedChange}
            {period && <span className="text-gray-500 ml-1" style={{fontSize:10}}>{period}</span>}
          </span>
        )}
      </div>
    </div>
  );
};

export default StatDisplay;